import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export enum ToolTipsAvailable {
  AppointmentStarTooltip = 'appointment-star-tooltip-dismissed',
  HeaderTermometroTooltip = 'header-termometro-tooltip-dismissed',
  HeaderNotificacaoTooltip = 'header-notificacao-tooltip-dismissed',
}

@Injectable({
  providedIn: 'root'
})

export class TooltipService {
  private tooltipVisibleSubject = new BehaviorSubject<boolean>(false);
  
  tooltipVisible$ = this.tooltipVisibleSubject.asObservable();

  constructor(private tooltip_key: string) {
  }

  shouldShowTooltip(): boolean {
    return localStorage.getItem(this.tooltip_key) !== 'true';
  }

  showTooltip(): void {
    if (this.shouldShowTooltip()) {
      this.tooltipVisibleSubject.next(true);
    }
  }

  hideTooltip(): void {
    this.tooltipVisibleSubject.next(false);
  }

  dismissTooltip(_dontShowAgain: boolean = true): void {
    this.hideTooltip();
    localStorage.setItem(this.tooltip_key, 'true');
  }
} 